import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import bindMethods from 'auto-bind';

import { fetchAllProducts } from '../../state/products';
import PageTitle from '../../components/PageTitle';
import SSOButton from '../../components/SSOButton';
import AddIcon from '../../icons/AddIcon';
import ProductsTable from '../../components/tables/ProductsTable';
import { HeadlineContainer } from '../../components/form/FormStyles';

class ListProducts extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  componentDidMount() {
    const { fetchAllProducts, isAllProductsLoaded } = this.props;

    if (!isAllProductsLoaded) {
      fetchAllProducts();
    }
  }

  handleAddNewProductClick() {
    const { history } = this.props;
    history.push('/products/new');
  }

  render() {
    const { t, isAllProductsLoaded, products } = this.props;

    if (!isAllProductsLoaded) {
      return null;
    }

    return (
      <div>
        <HeadlineContainer>
          <PageTitle title={t('Pages.Products.Headlines.Title')} />
          <SSOButton
            id="Products.AddNewProduct"
            icon={AddIcon}
            onClick={this.handleAddNewProductClick}
            text={t('Pages.Products.Actions.AddProduct')}
            isSmall
          />
        </HeadlineContainer>

        <ProductsTable products={products} />
      </div>
    );
  }
}

ListProducts.propTypes = {
  fetchAllProducts: PropTypes.func.isRequired, // supplied from Redux
  isAllProductsLoaded: PropTypes.bool.isRequired, // supplied from Redux
  products: PropTypes.array.isRequired, // supplied from Redux
  t: PropTypes.func.isRequired, // supplied from withTranslation
  history: PropTypes.object.isRequired, // supplied from React Router
};

const mapStateToProps = state => ({
  isAllProductsLoaded: state.products.isAllProductsLoaded, // supplied from Redux
  products: state.products.products, // supplied from Redux
});

const mapDispatchToProps = {
  fetchAllProducts,
};

const TranslatedComponent = withTranslation()(ListProducts);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranslatedComponent);
